<template>
    <v-card>
        <v-toolbar color="primary">
            <v-toolbar-title style="color: white">Estorno de Cartões</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-container flex>
                <v-layout column class="mb-2" justify-center align-center style="background-color: #e9e9e9">
                    <v-layout justify-center align-center>
                        <img class="mt-2" style="border-radius: 10em;" :src="cliente.pessoa.url_imagem_perfil" width="150"/>
                    </v-layout>
                    <v-layout column class="mb-2">
                        <h4>Cliente: {{`${cliente.pessoa.nome} ${cliente.pessoa.sobrenome}`}}</h4>
                        <h4>CPF: {{cliente.pessoa.cpf}}</h4>
                        <h4>Telefone: {{cliente.pessoa.telefone}}</h4>
                    </v-layout>
                </v-layout>
                <h3 v-if="msg" style="text-align: center;" class="mb-2 green--text"><v-icon color="green">check</v-icon>  Valor estornado com sucesso</h3>
                <v-layout row wrap>
                    <v-layout align-start justify-start row wrap fill-height>
                        <v-flex xs3 v-for="(cartao, index) in listas_cartoes" :key="index">
                            <v-menu offset-x>
                                <template v-slot:activator="{ on }">
                                    <v-card v-on="on" class="mt-2 card" style="width: 90%;">
                                        <v-layout justify-center class="pa-1">
                                            <v-icon size="40" v-if="cartao.verificado === 3 && cartao.cancelado === false" color="error">credit_card</v-icon>
                                            <v-icon size="40" v-else color="info">credit_card</v-icon>
                                        </v-layout>
                                        <v-card-text>
                                            <h5>Valor: R${{cartao.valor_verificacao}}</h5>
                                            <div v-html="formatDate(cartao.data_cancelamento)"></div>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <v-list>
                                    <v-list-tile
                                        @click="estornar(cartao, index)"
                                    >
                                        <v-list-tile-avatar>
                                            <v-icon color="primary">redo</v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-title>Estornar valor</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile
                                        @click="cancelarEstorno(cartao)"
                                    >
                                        <v-list-tile-avatar>
                                            <v-icon color="error">do_not_disturb</v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-title>Cancelar estorno</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                        </v-menu>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn block @click="fechar">Fechar</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: ['cliente'],
    data: () => ({
        listas_cartoes: [],
        msg: false
    }),
    methods: {
        fechar () {
            this.listas_cartoes = []
            this.$emit('fechar')
        },
        estornar (cartao, index) {
            if (cartao.verificado === 3 && cartao.cancelado === false) {
                this.$store.dispatch('estornarDinheiro', cartao.id_cartao).then(value => {
                    if (value) {
                        this.$emit('carregarClientes')
                        cartao.cancelado = true
                        this.msg = true
                        var interval = setInterval(() => {
                            this.msg = false
                            clearInterval(interval)
                        }, 10000)
                    }
                })
            }
        },
        cancelarEstorno (cartao) {
            if (cartao.verificado === 3 && cartao.cancelado === false) {
                this.$store.dispatch('cancelarEstorno', cartao.id_cartao).then(value => {
                    if (value) {
                        this.$emit('carregarClientes')
                        cartao.cancelado = true
                    }
                })
            }
        },
        formatDate (data) {
            if (data === null || data === undefined) {
                return ''
            }
            let str = String(data)
            let date = str.slice(0, 10)
            let time = str.slice(11, 16)
            let dia = date.slice(8, 10)
            let mes = date.slice(5, 7)
            let ano = date.slice(0, 4)
            date = `${dia}/${mes}/${ano}`
            return `
                <h5>data: ${date}</h5>
                <h5>Horário: ${time}</h5>
            `
        }
    },
    beforeMount () {
        if (this.cliente) {
            this.listas_cartoes = this.cliente.cartao_cliente
        }
    }
}
</script>

<style scoped>
.card {
    background-color: white;
    cursor: pointer;
}
.card:hover {
   background-color:#DCDCDC;
}
</style>
